/* eslint-disable no-unused-vars */
// noinspection JSUnusedGlobalSymbols
export enum LandscapeBuyerRelationType {
  Implementers = 'Implementers',
  Funders = 'Funders',
  CoalitionPartners = 'CoalitionPartners',
  BuyerConveners = 'BuyerConveners',
  BuyerImplementers = 'BuyerImplementers',
  Conveners = 'Conveners',
  Consortiums = 'Consortiums',
}
